import React, { Component, createRef } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import ChatsService from '../../controllers/ChatController';
import { withTranslation } from "react-i18next";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Toastr from '../utils/toastr';
class OutgoingChat extends Component {

    constructor(props) {
        super(props)
        this.inputFile = createRef();
        this.changeElement = createRef();
        this.state = {
            show: false,
            groups: [],
            channels: [],
            contacts: [],
            templates: [],
            channel: null,
            channelId: -1,
            groupId: -1,
            templateId: -1,
            template: null,
            messageType: 1,
            message: "",
            sendTo: "",
            loading: false
        }

        this.setLoading = this.setLoading.bind(this);
        this.showModal = this.showModal.bind(this);
        this.changeChannel = this.changeChannel.bind(this);
        this.changeMessageType = this.changeMessageType.bind(this);
        this.changeMessage = this.changeMessage.bind(this);
        this.changeTemplate = this.changeTemplate.bind(this);
        this.parameterChange = this.parameterChange.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.changeContacts = this.changeContacts.bind(this);
        this.groupChange = this.groupChange.bind(this);
        this.toastrRef = React.createRef();
    }

    setLoading(value) {
        this.setState({
            loading: value
        })
    }

    showModal = e => {
        let user = JSON.parse(localStorage.getItem("fc-logged"));
        this.setLoading(true);
        ChatsService.getChannels(user.userId, channels => {

            ChatsService.getGroups(user.userId, groups => {
                this.setState({
                    groups: groups,
                    groupId: groups != null && groups.length > 0 ? groups[0].id : -1
                });

                if (channels != null && channels.length > 0) {
                    let channel = channels[0];

                    this.setState({
                        channels: channels,
                        channel: channel,
                        channelId: channel.id
                    });

                    if (channel.channel.toLowerCase() === "telegram") {
                        ChatsService.getChannelContacts(channel.id, contacts => {
                            this.setState({
                                contacts: contacts
                            });
                            this.setLoading(false);
                        });
                    } else {
                        ChatsService.getFidelityContacts(user.userId, contacts => {
                            this.setState({
                                contacts: contacts
                            });
                            this.setLoading(false);
                        });
                    }
                } else {
                    this.setLoading(false);
                }
            })
        })
    }

    changeChannel = e => {
        let channelId = parseInt(e.target.value),
            channel = this.state.channels.find(x => x.id === channelId),
            user = JSON.parse(localStorage.getItem("fc-logged"))
        this.setState({ channelId: channel.id, channel: channel });

        if (channel.channel.toLowerCase() === "whatsapp") {
            this.setState({
                messageType: 0
            });
            ChatsService.getChannelTemplates(channel.id, templates => {
                let template = null;

                if (templates != null && templates.length > 0) {
                    template = templates[0];
                    templates.forEach(t => {
                        t.params.forEach(element => {
                            element.value = "";
                        });
                    });
                }

                this.setState({
                    templates: templates,
                    templateId: template ? templates[0].id : -1,
                    template: template
                });
            });
        } else {
            this.setState({
                messageType: 1,
                templates: [],
                templateId: -1,
                template: null
            });
        }

        if (channel.channel.toLowerCase() === "telegram") {
            ChatsService.getChannelContacts(channel.id, contacts => {
                this.setState({
                    contacts: contacts
                });
            });
        } else {
            ChatsService.getFidelityContacts(user.userId, contacts => {
                this.setState({
                    contacts: contacts
                });
            });
        }
    }

    changeMessageType = e => {
        let value = parseInt(e.target.value);

        if (value === 0) {

            ChatsService.getChannelTemplates(this.state.channelId, templates => {
                let template = null;

                if (templates != null && templates.length > 0) {
                    template = templates[0];
                    templates.forEach(t => {
                        t.params.forEach(element => {
                            element.value = "";
                        });
                    });
                }

                this.setState({
                    templates: templates,
                    templateId: template ? templates[0].id : -1,
                    template: template,
                    messageType: value
                });
            });
            
        } else {
            this.setState({
                templates: [],
                templateId: -1,
                template: null,
                messageType: value
            });
        }
    }

    changeMessage = e => {
        this.setState({
            message: e.target.value
        });
    }

    changeTemplate = e => {

        let templateId = parseInt(e.target.value),
            template = this.state.templates.find(x => x.id === templateId);

        this.setState({
            templateId: templateId,
            template: template
        });

    }

    parameterChange = (e, i) => {
        e.preventDefault();
        let template = this.state.template;
        template.params[i].value = e.target.value;

        this.setState({
            template: template
        });

    }

    changeContacts = e => {
        e.preventDefault();
        this.setState({
            sendTo: e.target.value
        });
    }

    groupChange = e => {
        e.preventDefault();
        this.setState({
            groupId: e.target.value
        });
    }

    sendMessage = e => {
        this.setLoading(true);
        let user = JSON.parse(localStorage.getItem("fc-logged"));
        if (this.state.messageType === 0) {
            let templateMessage = {
                from: this.state.channel.value,
                to: this.state.sendTo,
                template: this.state.template,
                params: this.state.template.params.map(x => { return { id: x.id, type: x.type, text: x.value } }),
                groupId: this.state.groupId,
                pin: user.userId,
                channelType: this.state.channel.type,
                channel: this.state.channel.channel.toLowerCase(),
                origin: "agent"
            };

            ChatsService.sendTemplate(templateMessage, x => {
                this.setLoading(false);
                if (x.data) {
                    this.props.toggleModal();
                    this.toastrRef.current.setType("success");
                    this.toastrRef.current.setMessage(this.props.t("sendok"));
                    this.toastrRef.current.show();
                } else {
                    this.toastrRef.current.setType("error");
                    this.toastrRef.current.setMessage(this.props.t("senderror"));
                    this.toastrRef.current.show();
                }
            });

        } else {
            let simpleMessage = {
                from: this.state.channel.value,
                to: this.state.sendTo,
                mediaType: "text",
                media: false,
                groupId: this.state.groupId,
                pin: user.userId,
                channel: this.state.channel.channel.toLowerCase(),
                date: new Date(),
                text: this.state.message
            };

            if (simpleMessage.from.startsWith("+"))
                simpleMessage.from = simpleMessage.from.substr(1);

            if (simpleMessage.text !== null && simpleMessage.text.trim() !== "") {

                if (this.inputFile.current.files.length > 0) {
                    let file = this.inputFile.current.files[0];
                    ChatsService.uploadFile(file, data => {
                        simpleMessage.mediaType = data.mediaType;
                        simpleMessage.url = data.url;
                        simpleMessage.media = true;
                        ChatsService.sendOutgoingMessage(simpleMessage, x => {
                            this.setLoading(false);
                            this.props.toggleModal();
                        });
                    });
                } else {
                    ChatsService.sendOutgoingMessage(simpleMessage, x => {
                        this.setLoading(false);
                        this.props.toggleModal();
                    });
                }
            }
        }
    }
    render() {
        return (
            <><Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                    <Modal.Header >
                        <Modal.Title><FontAwesomeIcon icon={faPaperPlane} /> {this.props.t("outgoingchat")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form>
                                    <Form.Group className="mb-4" controlId="fcGroup">
                                        <Form.Label>{this.props.t("group")}</Form.Label>
                                        <Form.Select onChange={this.groupChange} value={this.state.groupId}>
                                            {
                                                this.state.groups.map(elem => {
                                                    return <option key={elem.id} value={elem.id} >{elem.name}</option>
                                                })
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="fcChannel">
                                        <Form.Label>{this.props.t("channel")}</Form.Label>
                                        <Form.Select ref={this.changeElement} onChange={this.changeChannel} value={this.state.channelId}>
                                            {
                                                this.state.channels.map(elem => {
                                                    return <option key={elem.id} value={elem.id} >{elem.name}</option>
                                                })
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                    {
                                        (this.state.channel && this.state.channel.channel.toLowerCase() === "whatsapp") &&
                                        <Form.Group className="mb-4" controlId="fcMessageType">
                                            <Form.Label>{this.props.t("messagetype")}</Form.Label>
                                            <Form.Select onChange={this.changeMessageType} value={this.state.messageType}>
                                                <option value={1} >{this.props.t("message")}</option>
                                                <option value={0} >{this.props.t("template")}</option>
                                            </Form.Select>
                                        </Form.Group>
                                    }
                                    {
                                        (this.state.messageType === 0) &&

                                        <Form.Group className="mb-4" controlId="fcMessageType">
                                            <Form.Label>{this.props.t("template")}</Form.Label>
                                            <Form.Select onChange={this.changeTemplate} value={this.state.templateId}>
                                                {
                                                    this.state.templates.map(elem => {
                                                        return <option key={elem.id} value={elem.id} >{elem.name}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    }
                                    {
                                        (this.state.messageType === 0 && this.state.template != null && this.state.template.params != null && this.state.template.params.length > 0) &&

                                        <Form.Group className="mb-4" controlId="fcParameters">
                                            <Form.Label>{this.props.t("parameters")}</Form.Label>


                                            {
                                                this.state.template.params.map((elem, index) => {
                                                    return (
                                                        <Form.Group key={index} className="mb-4" controlId={"param_" + index}>
                                                            <Form.Label>{elem.name}</Form.Label>
                                                            <Form.Control type="text" value={elem.value} onChange={(e) => this.parameterChange(e, index)} />
                                                        </Form.Group>
                                                    )
                                                })
                                            }
                                        </Form.Group>
                                    }
                                    {
                                        (this.state.messageType === 1) &&

                                        <>
                                            <Form.Group className="mb-4" controlId="fcMessageType">
                                                <Form.Label>{this.props.t("message")}</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder={this.props.t("writeamessage")}
                                                    style={{ height: '100px' }}
                                                    onChange={this.changeMessage} value={this.state.message}
                                                />

                                            </Form.Group>
                                            <Form.Group className="mb-4" controlId="fcMessageType">
                                                <Form.Control
                                                    type="file"
                                                    ref={this.inputFile}
                                                    accept=".jpg, .jpeg, .png, .xls, .csv, .xlsx, .pdf, .doc, .docx, .mp4, .mp3, .mpeg, .wav" />
                                            </Form.Group>
                                        </>
                                    }
                                    <Form.Group className="mb-4" controlId="fcContacts">
                                        <Form.Label>{this.props.t("sendto")}</Form.Label>
                                        <Form.Control type="text" list="contacts" value={this.state.sendTo} onChange={this.changeContacts} />
                                        <datalist id="contacts">
                                            {this.state.contacts.map((item, key) =>
                                                <option key={key} value={item.id}>{item.name}</option>
                                            )}
                                        </datalist>
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.sendMessage}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                        </Button>
                    </Modal.Footer>
                </BlockUi>
            </Modal>
                <Toastr ref={this.toastrRef} />
            </>)
    }

}

export default withTranslation()(OutgoingChat);